import { type DeviceType } from '@service-initiation/tech-care-data-access-store';

export const deviceTypeCompleted = (deviceType?: DeviceType) =>
  deviceType !== undefined;
